"use client"

import redux from "../common/Redux"
import routes from "../routes/URL"
import { Link } from "react-router-dom"
import { Component } from "react"
import {
  Button,
  Popover,
  Typography,
  Box,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Divider,
} from "@mui/material"
import { LifeBuoy, LogOut, CreditCard, User } from "lucide-react"
import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material"
import { logOut } from "../common/util"

class LogoutButton extends Component {
  constructor(props) {
    super(props.props)
    this.state = {
      selectHotelDialogVisible: false,
      anchorEl: null,
      userData: {
        name: "",
      }
    }
    this.props = this.props.props
    console.log("Raw props received by component:", props)

    
  }


  handleLogout = () => {
    logOut(this.props.props)
  }

  handleSubcription = () => {
    window.push(routes.admin.subscription.root)
  }

  showSelectHotelDialog = () => {
    this.setState({
      selectHotelDialogVisible: true,
    })
  }

  componentDidMount() {
    const storedUser = JSON.parse(localStorage.getItem("user"))
    if (storedUser) {
      this.setState({
        userData: {
          name: storedUser.name || "",
        }
      })
    }
  }

  handleHotelSelection = (hotel) => {
    this.setState({
      selectHotelDialogVisible: false,
    })

    this.handleClose()

    this.props.setHotelSelectedId(hotel.id)
    window.location.reload()
  }

  // Helper function to check access control - similar to AdminNavigation
  hasAccess = (accessKey, featureKey = null) => {
    const { accessControl, activeFeatures = [] } = this.props

    // Check if user has the required access key
    if (!accessControl || !accessControl.includes(accessKey)) {
      return false
    }

    // If featureKey is specified, check if user has that feature
    if (featureKey) {
      const hasFeature = activeFeatures.some((f) => {
        return f.tag && f.tag.includes(featureKey)
      })

      if (!hasFeature) {
        return false
      }
    }

    return true
  }
  renderSelectHotelDialog = () => {
    const hotels = this.props.hotels
    const activeHotels = hotels.filter((h) => h.is_active.active)
    const inactiveHotels = hotels.filter((h) => !h.is_active.active)

    // Check access for Branch and Outlet buttons
    const canCreateBranch = this.hasAccess("hotel-branch")
    const canCreateOutlet = this.hasAccess("hotel-outlet")

    return (
      <Box
        sx={{
          width: 350,
          maxHeight: "80vh",
          bgcolor: "#041A29",
          color: "#ffffff",
          borderRadius: 1.5,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Scrollable content container */}
        <Box
          sx={{
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            flexGrow: 1,
          }}
        >
          {/* Restaurant Lists */}
          <Box sx={{ maxHeight: "100%", overflowY: "hidden" }}>
            {/* Active Restaurants */}
            {activeHotels.length > 0 && (
              <>
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    px: 2.5,
                    py: 1.5,
                    bgcolor: "#041A29",
                    color: "rgba(255,255,255,0.7)",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    fontSize: "0.75rem",
                  }}
                >
                  YOUR RESTRO's
                </Typography>

                <List disablePadding>
                  {activeHotels.map((item, index) => (
                    <ListItem
                      key={index}
                      button
                      onClick={() => this.handleHotelSelection(item)}
                      sx={{
                        px: 2.5,
                        py: 1.5,
                        backgroundColor: "#02111B",
                        "&:hover": {
                          backgroundColor: "#041A29",
                        },
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 45 }}>
                        <Avatar
                          src={
                            item.hotel_photo && item.hotel_photo.length > 0
                              ? item.hotel_photo[0].photo
                              : ""
                          }
                          sx={{
                            width: 38,
                            height: 38,
                            bgcolor: "#FFC857",
                            color: "#000000",
                          }}
                        />

                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box sx={{}}>
                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.9rem" }}>
                              {item.hotel_name}
                            </Typography>

                          </Box>
                        }
                        secondary={
                          <>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "rgba(255,255,255,0.5)",
                                fontSize: "0.8rem",
                              }}
                            >
                              {item.hotel_phone.length > 0 ? item.hotel_phone[0].phone : ""}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "rgba(255,255,255,0.5)",
                                fontSize: "0.7rem",
                                textTransform: "capitalize",
                              }}
                            >
                              {item.outlet_category}
                            </Typography>
                            {index > 0 && (
                              <Typography
                                variant="caption"
                                sx={{

                                  color: item.is_outlet ? '#FFC857' : '#0BB783',
                                  bgcolor: '#041A29',
                                  px: 1,
                                  py: 0.25,
                                  borderRadius: 1,
                                  fontSize: '0.65rem',
                                  fontWeight: 600
                                }}
                              >
                                {item.is_outlet ? 'Outlet' : 'Branch'}
                              </Typography>
                            )}
                          </>
                        }

                        sx={{ my: 0.5 }}
                      />

                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          bgcolor: "#0BB783",
                          ml: 1.5,
                        }}
                      />

                    </ListItem>
                  ))}
                </List>
              </>
            )}

            {/* Inactive Restaurants */}
            {inactiveHotels.length > 0 && (
              <>
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    px: 2.5,
                    py: 1.5,
                    bgcolor: "#151521",
                    color: "rgba(255,255,255,0.7)",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    fontSize: "0.75rem",
                  }}
                >
                  INACTIVE RESTAURANTS
                </Typography>

                <List disablePadding>
                  {inactiveHotels.map((item, index) => (
                    <ListItem
                      key={index}
                      button
                      onClick={() => this.handleHotelSelection(item)}
                      sx={{
                        px: 2.5,
                        py: 1.5,
                        borderLeft: "3px solid transparent",
                        "&:hover": {
                          bgcolor: "rgba(255,255,255,0.05)",
                          borderLeft: "3px solid #F64E60",
                        },
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 45 }}>
                        <Avatar
                          src={
                            item.hotel_photo.length > 0
                              ? item.hotel_photo[0].photo
                              : "https://www.pngitem.com/pimgs/m/146-1468479_my-profile-icon-blank-profile-picture-circle-hd.png"
                          }
                          sx={{ width: 38, height: 38 }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.9rem" }}>
                            {item.hotel_name}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)", fontSize: "0.8rem" }}>
                            {item.hotel_phone.length > 0 ? item.hotel_phone[0].phone : ""}
                          </Typography>
                        }
                        sx={{ my: 0.5 }}
                      />
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          bgcolor: "#F64E60",
                          ml: 1.5,
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </>
            )}
          </Box>

          {/* Divider between restaurants and menu options */}
          <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", my: 1 }} />

          {/* Google Translate Widget */}
          <Box sx={{ px: 4, py: 1 }}></Box>

          {/* Menu Options */}
          <div style={{ paddingLeft: "20px" }}>
            {[
              {
                label: "Subscriptions",
                icon: <CreditCard color="#FFC857" />,
                isLink: true,
                to: routes.admin.subscriptions.root(this.props.hotels[0]?.hotel_slug || ''),
                accessKey: "hotel-settings", // Add access control
              },
              {
                label: "My Account",
                icon: <User color="#FFC857" />,
                isLink: true,
                to: routes.admin.profile.root(this.props.hotels[0]?.hotel_slug || ''),
                accessKey: "hotel-settings", // Add access control
              },
              {
                label: "Support",
                icon: <LifeBuoy color="#FFC857" />,
                smallIcon: true,
                isLink: true,
                to: routes.admin.support.root(this.props.hotels[0]?.hotel_slug || ''),
                accessKey: "hotel-settings", // Add access control
              },
              // In the menu options array of LogoutButton component
              {
                label: "My Login Details",
                icon: <User color="#FFC857" />,
                isLink: true,
                to: routes.admin.loginInfo.root(
                  this.props.hotels[0]?.hotel_slug,
                  this.state.userData.name // Fixed: Access userData from state
                ),
                accessKey: "hotel-settings",
              },
              {
                label: "Logout",
                icon: <LogOut color="#FFC857" />,
                // No access control needed for logout
              },
            ]
              .filter((item) => !item.accessKey || this.hasAccess(item.accessKey)) // Filter based on access control
              .map((item, index) => {
                if (item.isLink) {
                  return (
                    <Button
                      key={index}
                      component={Link}
                      to={item.to}
                      startIcon={item.icon}
                      style={{
                        color: "white",
                        textAlign: "left",
                        justifyContent: "flex-start",
                        width: "100%",
                        padding: "8px 16px",
                        textTransform: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#02111B"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent"
                      }}
                    >
                      {item.label}
                    </Button>
                  )
                }

                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      color: "white",
                      fontSize: "0.9rem",
                      minHeight: "36px",
                      cursor: "pointer",
                      textTransform: "none",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      marginBottom: "4px",
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#02111B"
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent"
                    }}
                    onClick={() => {
                      if (item.label === "Logout") {
                        this.handleLogout()
                      }
                    }}
                  >
                    <div
                      style={{
                        fontSize: item.smallIcon ? "10px" : "14px",
                        marginRight: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {item.icon}
                    </div>
                    {item.label}
                  </div>
                )
              })}
          </div>

          {/* Bottom Action Buttons - Now with Access Control */}
          {(canCreateBranch || canCreateOutlet) && (
            <Box
              sx={{
                p: 2.5,
                borderTop: "1px solid rgba(255,255,255,0.1)",
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              {/* Add New Branch/Outlet Section */}
              <Box
                sx={{
                  p: 2.5,
                  bgcolor: "#02111B",
                  borderRadius: "8px",
                  color: "#1e1e2d",
                  mb: 1.5,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    mb: 2,
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    color: "white",
                  }}
                >
                  {canCreateBranch && canCreateOutlet
                    ? "Add a new branch or outlet to expand your restaurant's reach!"
                    : canCreateBranch
                      ? "Add a new branch to expand your restaurant's reach!"
                      : "Add a new outlet to expand your restaurant's reach!"}
                </Typography>

                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                  {/* Branch Button - Only show if user has access */}
                  {canCreateBranch && (
                    <Button
                      component={Link}
                      to={routes.admin.hotels.create}
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: "#FFC857",
                        "&:hover": {
                          bgcolor: "#FFC857",
                        },
                        textTransform: "none",
                        fontWeight: 700,
                        py: 1,
                        borderRadius: "4px",
                        color: "black",
                        boxShadow: "none",
                        mb: 1.5,
                        fontSize: "0.9rem",
                      }}
                    >
                      Branch +
                    </Button>
                  )}

                  {/* Outlet Button - Only show if user has access */}
                  {canCreateOutlet && (
                    <Button
                      component={Link}
                      to={routes.admin.outlet.create}
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: "#02111B",
                        border: "1px solid #FFC857",
                        "&:hover": {
                          bgcolor: "#02111B",
                        },
                        textTransform: "none",
                        fontWeight: 700,
                        py: 1,
                        borderRadius: "4px",
                        color: "white",
                        boxShadow: "none",
                        mb: 1.5,
                        fontSize: "0.9rem",
                      }}
                    >
                      Outlet +
                    </Button>
                  )}
                </div>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    )
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { selectHotelDialogVisible } = this.state
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: {
              bgcolor: "transparent",
              boxShadow: "none",
              mt: 1.5,
            },
          }}
        >
          {this.renderSelectHotelDialog()}
        </Popover>

        {selectHotelDialogVisible === false && this.props.selectedHotelId && (
          <Tooltip title="Change restaurant" arrow>
            <Button
              onClick={this.handleOpen}
              endIcon={<ArrowDropDownIcon sx={{ fontSize: "1.2rem" }} />}
              sx={{
                bgcolor: "#041A29",
                color: "white",
                "&:hover": {
                  bgcolor: "#041A29",
                },
                textTransform: "none",
                borderRadius: 1.5,
                px: 2,
                py: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {this.props.selectedHotelId && this.props.selectedHotelId.hotel_photo.length > 0 && (
                  <Avatar
                    src={this.props.selectedHotelId.hotel_photo.length > 0 ? this.props.selectedHotelId.hotel_photo[0].photo : ""} sx={{
                      width: 32,
                      height: 32,
                      mr: 1.5,
                    }}
                  />
                )}
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.9rem" }}>
                  {this.props.selectedHotelId.hotel_name}
                </Typography>
              </Box>
            </Button>
          </Tooltip>
        )}
      </Box>
    )
  }
}

export default redux(LogoutButton)
